import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { Loading } from '../components/atoms/Loader';
import { driverStateAtom } from '../services/recoil/atoms/driverState';
import { signatureStateAtom } from '../services/recoil/atoms/signatureState';

function ImageWithAuth({ signature }: { signature?: string }) {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const driver = useRecoilValue(driverStateAtom);
  const signatureState = useRecoilValue(signatureStateAtom);
  const [imgSrc, setImgSrc] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    let imageUrl = '';

    const loadImage = async () => {
      if (!isAuthenticated || !(driver?.signature || signature)) {
        if (isMounted) {
          setImgSrc('');
          setIsLoading(false);
        }
        return;
      }

      try {
        setIsLoading(true);
        const token = await getAccessTokenSilently();
        const response = await fetch(
          `${process.env.REACT_APP_FILE_URL}${
            signature || driver?.signature
          }&${Date.now()}`,
          {
            headers: new Headers({
              Authorization: `Bearer ${token}`,
              'apollo-require-preflight': 'true',
              'Accept-Encoding': 'gzip, deflate, br',
            }),
          },
        );

        const blob = await response.blob();
        imageUrl = URL.createObjectURL(blob);

        if (isMounted) {
          setImgSrc(imageUrl);
        }
      } catch {
        if (isMounted) {
          setImgSrc('');
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    loadImage();

    return () => {
      isMounted = false;
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
    };
  }, [
    driver?.signature,
    getAccessTokenSilently,
    isAuthenticated,
    signature,
    signatureState,
  ]);

  return isLoading ? (
    <Loading size={50} />
  ) : (
    <div className="flex w-full items-center justify-center">
      {imgSrc && <img src={imgSrc} alt="Driver's signature" className="w-80" />}
    </div>
  );
}

export default ImageWithAuth;
